import { render } from "./ActivityUpdateStatusButton.vue?vue&type=template&id=47c5073f&scoped=true"
import script from "./ActivityUpdateStatusButton.vue?vue&type=script&lang=js"
export * from "./ActivityUpdateStatusButton.vue?vue&type=script&lang=js"

import "./ActivityUpdateStatusButton.vue?vue&type=style&index=0&id=47c5073f&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47c5073f"]])

export default __exports__